import type { ErrorEvent } from '@sentry/react';

const storeResetMessages = [
  'Store reset while query was in flight (not completed in link chain)',
  `https://go.apollo.dev/c/err#${encodeURIComponent(
    JSON.stringify({ version: '3.13.8', message: 34, args: [] }),
  )}`,
];

export const isApolloStoreResetEvent = ({ exception }: ErrorEvent) =>
  exception?.values?.some(({ value }) =>
    storeResetMessages.some((message) => value?.includes(message)),
  ) ?? false;
